import React, { useState } from 'react';
import { Col, Container, Row, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { useParams } from 'react-router-dom';
import classnames from 'classnames';
import SandboxEndpointsTable from './SandboxEndpointsTable';
import ProductionEndpointsTable from './ProductionEndpointsTable';


const ProjectEndpoints = () => {
    const { projectId } = useParams();
    const [activeTab, setActiveTab] = useState<string>('sandbox');

    const toggleTab = (tab: string) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Endpoints" pageTitle="Projects" />

                    {/* Environment Tabs */}
                    <Row className="mb-3">
                        <Col xl={12}>
                            <Nav tabs className="nav-tabs-custom nav-success">
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: 'pointer' }}
                                        className={classnames({ active: activeTab === 'sandbox' })}
                                        onClick={() => toggleTab('sandbox')}
                                    >
                                        <i className="ri-flask-line me-1 align-bottom"></i>
                                        Sandbox
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: 'pointer' }}
                                        className={classnames({ active: activeTab === 'production' })}
                                        onClick={() => toggleTab('production')}
                                    >
                                        <i className="ri-rocket-line me-1 align-bottom"></i>
                                        Production
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={12}>
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId="sandbox">
                                    <SandboxEndpointsTable projectId={projectId} />
                                </TabPane>
                                <TabPane tabId="production">
                                    <ProductionEndpointsTable projectId={projectId} />
                                </TabPane>
                            </TabContent>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default ProjectEndpoints;